module.exports = __webpack_public_path__ + "img/delete.d42ca299.svg";